// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/event_packing.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventInventoryDemand, EventPlanInputChange } from "./event_plan_pb";
import { file_cortado_v1_event_plan } from "./event_plan_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/event_packing.proto.
 */
export const file_cortado_v1_event_packing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_event_plan, file_google_protobuf_timestamp]);

/**
 * @generated from message cortado.v1.EventPackingItem
 */
export type EventPackingItem = Message<"cortado.v1.EventPackingItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * @generated from field: cortado.v1.EventPackingItemSourceEnum source = 3;
   */
  source: EventPackingItemSourceEnum;

  /**
   * Stable key of the generated line; empty on manual rows.
   *
   * @generated from field: string line_key = 4;
   */
  lineKey: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * Trimmed category; empty for uncategorized rows. Add-on rows use "Add-ons".
   *
   * @generated from field: string category = 6;
   */
  category: string;

  /**
   * @generated from field: string unit_name = 7;
   */
  unitName: string;

  /**
   * @generated from field: string unit_size = 8;
   */
  unitSize: string;

  /**
   * Free-text note (manual rows).
   *
   * @generated from field: string detail = 9;
   */
  detail: string;

  /**
   * Computed at generation, or entered for manual rows.
   *
   * @generated from field: int32 quantity = 10;
   */
  quantity: number;

  /**
   * Set by hand on a computed or add-on row. Manual rows never carry one.
   *
   * @generated from field: optional int32 override_quantity = 11;
   */
  overrideQuantity?: number;

  /**
   * override_quantity when set, else quantity. What to pack.
   *
   * @generated from field: int32 effective_quantity = 12;
   */
  effectiveQuantity: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp packed_at = 13;
   */
  packedAt?: Timestamp;

  /**
   * User who marked the row packed.
   *
   * @generated from field: optional string packed_by = 14;
   */
  packedBy?: string;

  /**
   * @generated from field: int32 sort_order = 15;
   */
  sortOrder: number;

  /**
   * @generated from field: optional string addon_offer_id = 16;
   */
  addonOfferId?: string;
};

/**
 * Describes the message cortado.v1.EventPackingItem.
 * Use `create(EventPackingItemSchema)` to create a new message.
 */
export const EventPackingItemSchema: GenMessage<EventPackingItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 0);

/**
 * EventPackingList is an event's saved packing list plus how it compares with
 * the event's current inputs.
 *
 * @generated from message cortado.v1.EventPackingList
 */
export type EventPackingList = Message<"cortado.v1.EventPackingList"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * Rows in display order. Group by category in first-appearance order.
   *
   * @generated from field: repeated cortado.v1.EventPackingItem items = 2;
   */
  items: EventPackingItem[];

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 3;
   */
  generatedAt?: Timestamp;

  /**
   * User who generated or last regenerated the list; unset for the system
   * (generated at booking from the customer portal, or on first view).
   *
   * @generated from field: optional string generated_by = 4;
   */
  generatedBy?: string;

  /**
   * @generated from field: string inputs_fingerprint = 5;
   */
  inputsFingerprint: string;

  /**
   * Drink demand from the inputs the list was generated from.
   *
   * @generated from field: cortado.v1.EventInventoryDemand demand = 6;
   */
  demand?: EventInventoryDemand;

  /**
   * Inputs the list was generated from, for the summary line.
   *
   * @generated from field: int32 guests = 7;
   */
  guests: number;

  /**
   * @generated from field: double event_length_hours = 8;
   */
  eventLengthHours: number;

  /**
   * @generated from field: double drinks_per_guest = 9;
   */
  drinksPerGuest: number;

  /**
   * @generated from field: int32 max_drinks_per_hour = 10;
   */
  maxDrinksPerHour: number;

  /**
   * @generated from field: int32 buffer_percentage = 11;
   */
  bufferPercentage: number;

  /**
   * The event's current inputs differ from the ones the list was made from.
   * Regenerate brings the list up to date.
   *
   * @generated from field: bool stale = 12;
   */
  stale: boolean;

  /**
   * What differs, worded for the stale notice. Empty when not stale.
   *
   * @generated from field: repeated cortado.v1.EventPlanInputChange changes = 13;
   */
  changes: EventPlanInputChange[];

  /**
   * Rows with something to pack (effective quantity above zero), and how many
   * of those are packed.
   *
   * @generated from field: int32 packed_count = 14;
   */
  packedCount: number;

  /**
   * @generated from field: int32 total_count = 15;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.EventPackingList.
 * Use `create(EventPackingListSchema)` to create a new message.
 */
export const EventPackingListSchema: GenMessage<EventPackingList> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 1);

/**
 * @generated from message cortado.v1.GetEventPackingListRequest
 */
export type GetEventPackingListRequest = Message<"cortado.v1.GetEventPackingListRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.GetEventPackingListRequest.
 * Use `create(GetEventPackingListRequestSchema)` to create a new message.
 */
export const GetEventPackingListRequestSchema: GenMessage<GetEventPackingListRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 2);

/**
 * GetEventPackingListResponse returns the saved list, generating it first
 * when the event has none yet.
 *
 * @generated from message cortado.v1.GetEventPackingListResponse
 */
export type GetEventPackingListResponse = Message<"cortado.v1.GetEventPackingListResponse"> & {
  /**
   * @generated from field: cortado.v1.EventPackingList packing_list = 1;
   */
  packingList?: EventPackingList;
};

/**
 * Describes the message cortado.v1.GetEventPackingListResponse.
 * Use `create(GetEventPackingListResponseSchema)` to create a new message.
 */
export const GetEventPackingListResponseSchema: GenMessage<GetEventPackingListResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 3);

/**
 * @generated from message cortado.v1.RegenerateEventPackingListRequest
 */
export type RegenerateEventPackingListRequest = Message<"cortado.v1.RegenerateEventPackingListRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.RegenerateEventPackingListRequest.
 * Use `create(RegenerateEventPackingListRequestSchema)` to create a new message.
 */
export const RegenerateEventPackingListRequestSchema: GenMessage<RegenerateEventPackingListRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 4);

/**
 * RegenerateEventPackingListResponse returns the rebuilt list. Computed and
 * add-on rows lose their overrides and packed marks; manual rows are kept.
 *
 * @generated from message cortado.v1.RegenerateEventPackingListResponse
 */
export type RegenerateEventPackingListResponse = Message<"cortado.v1.RegenerateEventPackingListResponse"> & {
  /**
   * @generated from field: cortado.v1.EventPackingList packing_list = 1;
   */
  packingList?: EventPackingList;
};

/**
 * Describes the message cortado.v1.RegenerateEventPackingListResponse.
 * Use `create(RegenerateEventPackingListResponseSchema)` to create a new message.
 */
export const RegenerateEventPackingListResponseSchema: GenMessage<RegenerateEventPackingListResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 5);

/**
 * @generated from message cortado.v1.SetEventPackingItemPackedRequest
 */
export type SetEventPackingItemPackedRequest = Message<"cortado.v1.SetEventPackingItemPackedRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: bool packed = 3;
   */
  packed: boolean;
};

/**
 * Describes the message cortado.v1.SetEventPackingItemPackedRequest.
 * Use `create(SetEventPackingItemPackedRequestSchema)` to create a new message.
 */
export const SetEventPackingItemPackedRequestSchema: GenMessage<SetEventPackingItemPackedRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 6);

/**
 * @generated from message cortado.v1.SetEventPackingItemPackedResponse
 */
export type SetEventPackingItemPackedResponse = Message<"cortado.v1.SetEventPackingItemPackedResponse"> & {
  /**
   * @generated from field: cortado.v1.EventPackingItem item = 1;
   */
  item?: EventPackingItem;
};

/**
 * Describes the message cortado.v1.SetEventPackingItemPackedResponse.
 * Use `create(SetEventPackingItemPackedResponseSchema)` to create a new message.
 */
export const SetEventPackingItemPackedResponseSchema: GenMessage<SetEventPackingItemPackedResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 7);

/**
 * @generated from message cortado.v1.SetEventPackingItemQuantityRequest
 */
export type SetEventPackingItemQuantityRequest = Message<"cortado.v1.SetEventPackingItemQuantityRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * On a computed or add-on row this is the override; unset clears it back to
   * the computed quantity. On a manual row it replaces the quantity (unset
   * leaves it unchanged). 0 to 100000.
   *
   * @generated from field: optional int32 quantity = 3;
   */
  quantity?: number;
};

/**
 * Describes the message cortado.v1.SetEventPackingItemQuantityRequest.
 * Use `create(SetEventPackingItemQuantityRequestSchema)` to create a new message.
 */
export const SetEventPackingItemQuantityRequestSchema: GenMessage<SetEventPackingItemQuantityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 8);

/**
 * @generated from message cortado.v1.SetEventPackingItemQuantityResponse
 */
export type SetEventPackingItemQuantityResponse = Message<"cortado.v1.SetEventPackingItemQuantityResponse"> & {
  /**
   * @generated from field: cortado.v1.EventPackingItem item = 1;
   */
  item?: EventPackingItem;
};

/**
 * Describes the message cortado.v1.SetEventPackingItemQuantityResponse.
 * Use `create(SetEventPackingItemQuantityResponseSchema)` to create a new message.
 */
export const SetEventPackingItemQuantityResponseSchema: GenMessage<SetEventPackingItemQuantityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 9);

/**
 * @generated from message cortado.v1.AddEventPackingItemRequest
 */
export type AddEventPackingItemRequest = Message<"cortado.v1.AddEventPackingItemRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * Required, at most 200 characters.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * At most 100 characters; empty files the row under "Other".
   *
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * 0 to 100000.
   *
   * @generated from field: int32 quantity = 4;
   */
  quantity: number;

  /**
   * At most 50 characters.
   *
   * @generated from field: string unit_name = 5;
   */
  unitName: string;

  /**
   * At most 500 characters.
   *
   * @generated from field: string detail = 6;
   */
  detail: string;
};

/**
 * Describes the message cortado.v1.AddEventPackingItemRequest.
 * Use `create(AddEventPackingItemRequestSchema)` to create a new message.
 */
export const AddEventPackingItemRequestSchema: GenMessage<AddEventPackingItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 10);

/**
 * @generated from message cortado.v1.AddEventPackingItemResponse
 */
export type AddEventPackingItemResponse = Message<"cortado.v1.AddEventPackingItemResponse"> & {
  /**
   * @generated from field: cortado.v1.EventPackingItem item = 1;
   */
  item?: EventPackingItem;
};

/**
 * Describes the message cortado.v1.AddEventPackingItemResponse.
 * Use `create(AddEventPackingItemResponseSchema)` to create a new message.
 */
export const AddEventPackingItemResponseSchema: GenMessage<AddEventPackingItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 11);

/**
 * @generated from message cortado.v1.DeleteEventPackingItemRequest
 */
export type DeleteEventPackingItemRequest = Message<"cortado.v1.DeleteEventPackingItemRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * A manual row. Computed and add-on rows cannot be deleted
   * (FailedPrecondition); set their quantity to 0 instead.
   *
   * @generated from field: string item_id = 2;
   */
  itemId: string;
};

/**
 * Describes the message cortado.v1.DeleteEventPackingItemRequest.
 * Use `create(DeleteEventPackingItemRequestSchema)` to create a new message.
 */
export const DeleteEventPackingItemRequestSchema: GenMessage<DeleteEventPackingItemRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 12);

/**
 * @generated from message cortado.v1.DeleteEventPackingItemResponse
 */
export type DeleteEventPackingItemResponse = Message<"cortado.v1.DeleteEventPackingItemResponse"> & {
};

/**
 * Describes the message cortado.v1.DeleteEventPackingItemResponse.
 * Use `create(DeleteEventPackingItemResponseSchema)` to create a new message.
 */
export const DeleteEventPackingItemResponseSchema: GenMessage<DeleteEventPackingItemResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_packing, 13);

/**
 * @generated from enum cortado.v1.EventPackingItemSourceEnum
 */
export enum EventPackingItemSourceEnum {
  /**
   * @generated from enum value: EVENT_PACKING_ITEM_SOURCE_UNSPECIFIED = 0;
   */
  EVENT_PACKING_ITEM_SOURCE_UNSPECIFIED = 0,

  /**
   * From the org's inventory settings.
   *
   * @generated from enum value: EVENT_PACKING_ITEM_SOURCE_COMPUTED = 1;
   */
  EVENT_PACKING_ITEM_SOURCE_COMPUTED = 1,

  /**
   * From an add-on accepted on the booking quote.
   *
   * @generated from enum value: EVENT_PACKING_ITEM_SOURCE_ADDON = 2;
   */
  EVENT_PACKING_ITEM_SOURCE_ADDON = 2,

  /**
   * Added by hand on this event. Kept by Regenerate.
   *
   * @generated from enum value: EVENT_PACKING_ITEM_SOURCE_MANUAL = 3;
   */
  EVENT_PACKING_ITEM_SOURCE_MANUAL = 3,
}

/**
 * Describes the enum cortado.v1.EventPackingItemSourceEnum.
 */
export const EventPackingItemSourceEnumSchema: GenEnum<EventPackingItemSourceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_event_packing, 0);

